/* 數字模板 ---> 訂單序號 / 發票號碼 */
<template>
  <cus-dialog>
    <template v-slot:body>
      <div class="computer">
        <!-- 顯示欄位 -->
        <div class="compute-number">
          <p class="result">{{ computeNum }}</p>
        </div>
        <!-- 數字鍵 -->
        <div class="number-button">
          <cus-button
            v-for="num in 9"
            :key="num"
            :text="num.toString()"
            @click="handleNumber(num)"
            :disabled="key === cusProps.limit"
          ></cus-button>
          <cus-button
            text="0"
            style="grid-area: 4/1/5/3"
            @click="handleNumber(0)"
            :disabled="key === cusProps.limit"
          ></cus-button>
          <cus-button
            topIcon="arrow-left"
            topIconClass="back-arrow"
            @click="handleBack"
            :disabled="back === cusProps.limit"
          ></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          :text="style.confirmButtonText || '確認'"
          :color="style.confirmButtonColor || 'blue'"
          :width="50"
          @click="submit(computeNum)"
          :disabled="computeNum === '0'.repeat(cusProps.limit)"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { ref, inject } from 'vue';
export default {
  name: 'number-limit-input',
  setup() {
    // const { proxy } = getCurrentInstance();
    //接受provide值
    const dialogVisible = inject('dialogVisible', false);
    const close = inject('close');
    const submit = inject('submit');
    const { style } = inject('style');
    const { cusProps } = inject('cusProps');
    //設定參數
    const computeNum = ref(null); //顯示數值
    const key = ref(null);
    const back = ref(null);
    //設定初始值
    if (dialogVisible) {
      if (cusProps.init) {
        computeNum.value = JSON.parse(JSON.stringify(cusProps.init));
        key.value = Number(cusProps.init).toString().length;
        back.value = cusProps.limit - key.value;
      } else {
        computeNum.value = '0'.repeat(cusProps.limit);
        key.value = 0;
        back.value = cusProps.limit;
      }
    }

    //按數字
    const handleNumber = (num) => {
      if (computeNum.value === '0'.repeat(cusProps.limit) && num === 0) return;
      computeNum.value = computeNum.value.slice(1) + num;
      key.value += 1;
      back.value -= 1;
    };
    //消除數字
    const handleBack = () => {
      computeNum.value = 0 + computeNum.value.slice(0, cusProps.limit - 1);
      key.value -= 1;
      back.value += 1;
    };
    return {
      close,
      submit,
      style,
      cusProps,
      computeNum,
      key,
      back,
      handleNumber,
      handleBack,
    };
  },
};
</script>
<style lang="scss" scoped>
.computer {
  @include computer-basic;
}
</style>
